import { render, staticRenderFns } from "./NostoLink.vue?vue&type=template&id=765fa5c7&"
import script from "./NostoLink.vue?vue&type=script&lang=js&"
export * from "./NostoLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports